module.exports = __webpack_public_path__ + "img/wide.d82cd6e9.jpg";